import styled from 'styled-components';
import { ZIndex } from '../../../styles/constants';
import { ieOnly } from '../../../styles/ieOnly';
import { onMobile } from '../../../styles/onMobile';
import { propSwitch } from '../../../util/propSwitch';

export const SearchHeaderContainer = styled.div<{ showingBranchBanner?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  left: 0;
  margin-top: ${propSwitch('showingBranchBanner', '50px', '0')};
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: ${ZIndex.SEARCH_OVERLAY};
`;

export const ScrollRelativeParent = styled.div<{ activeId: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  z-index: ${ZIndex.NORMAL};

  ${onMobile} {
    /**
     * overflow: hidden breaks the z-index of the search header in safari.
     * unset overflow to have the search header go below the overlay when active.
     */
    overflow: ${propSwitch('activeId', 'unset', 'hidden')};
  }
`;

export const ContentScrollContainer = styled.div<{ scrollLocked: boolean }>`
  /*
  * the search Header on ios safari presents incorrectly when a overlay is showing and
  * touch scrolling is set on a parent container
  */
  -webkit-overflow-scrolling: ${propSwitch('scrollLocked', 'auto', 'touch')};
  flex: 1;
  overflow-y: ${propSwitch('scrollLocked', 'hidden', 'scroll')};
`;

export const ScrollContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;

  ${ieOnly} {
    display: block;
  }
`;

export const ContentOffset = styled.div`
  flex: 1;
`;
